import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * /clean — Limpia todo el estado local del navegador y redirige al login.
 * Usar cuando una nueva versión del app genera comportamientos inesperados.
 */
export const CleanPage = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<string>('Limpiando caché...');

  useEffect(() => {
    const clean = async () => {
      // 1. localStorage y sessionStorage
      try { localStorage.clear(); } catch { /* noop */ }
      try { sessionStorage.clear(); } catch { /* noop */ }

      // 2. Service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(r => r.unregister()));
      }

      // 3. Cache API
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }

      setStatus('¡Listo! Redirigiendo...');
      setTimeout(() => navigate('/login', { replace: true }), 800);
    };

    clean();
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: '1rem',
      fontFamily: 'sans-serif',
      color: '#4b5563',
    }}>
      <div style={{ fontSize: '2rem' }}>🧹</div>
      <p style={{ margin: 0, fontSize: '1rem', fontWeight: 500 }}>{status}</p>
    </div>
  );
};
